import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
  registrationLinkUsedAtLogin: null
};

const getters = {
  registrationLinkUsedAtLogin(state) {
    return state.registrationLinkUsedAtLogin;
  },
  registrationLinkAssociatedWithUser(state, getters, rootState, rootGetters) {
    // get reg link from me object
    const me = rootGetters.me;
    if (me && me.registrationLink) {
      return me.registrationLinkUsed;
    }
    return null;
  },
  activeRegistrationLink(state, getters) {
    const userLink = getters.registrationLinkAssociatedWithUser;
    if (userLink) {
      return userLink;
    }
    return getters.registrationLinkUsedAtLogin;
  }
};

const mutations = {
  setRegistrationLinkUsedAtLogin(state, registrationLink) {
    state.registrationLinkUsedAtLogin = registrationLink;
  }
};

const actions = {
  async createRegistrationLink(_, registrationLink) {
    if (registrationLink.uniqueIdClass !== undefined && registrationLink.uniqueIdClass !== null && registrationLink.uniqueIdClass.trim() === '') {
      registrationLink.uniqueIdClass = null;
    }
    const response = await axios.post('/blade/registration-link', registrationLink);
    return response.data.registrationLink;
  },
  async getRegistrationLinks() {
    const response = await axios.get('/blade/registration-link');
    return response.data.registrationLinks;
  },
  async getRegistrationLinkByLink(_, link) {
    const { registrationLink } = (await axios.get(`/blade/registration-link/link/${link}`)).data;
    return registrationLink;
  },
  async getRegistrationLinkAdditionalUserFields(_, { _id, registrationLinkId }) {
    const id = _id || registrationLinkId;
    const response = await axios.get(`/blade/registration-link/${id}/additionalFields`);
    return response.data.fields;
  },
  async getRegistrationLink(_, { registrationLinkId }) {
    const { data } = await axios.get(`/blade/registration-link/${registrationLinkId}`);
    return data;
  },
  async updateRegistrationLink(_, registrationLink) {
    if (registrationLink.uniqueIdClass !== undefined && registrationLink.uniqueIdClass !== null && registrationLink.uniqueIdClass.trim() === '') {
      registrationLink.uniqueIdClass = null;
    }
    const response = await axios.patch(`/blade/registration-link/${registrationLink._id}`, registrationLink);
    return response.data.registrationLink;
  },
  async deleteRegistrationLink(_, { registrationLinkId, _id }) {
    const did = registrationLinkId || _id;
    const response = await axios.delete(`/blade/registration-link/${did}`);
    return response.data.registrationLink;
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/registration-link.js